import { getToken, showLoading, hideLoading, ENV } from '@/utils'
import axios from 'axios'
import { showDialog } from 'vant'
import { login } from './api'

export const BASE_URL = window.location.href.indexOf('test.patrol.h5.xiaoqiandao.com') > -1 ||
  ENV == 'TEST'
  ? 'https://pre.weiyoubot.cn/patrol'
  : 'https://api-xcx-qunsou.weiyoubot.cn/patrol'

const request = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
})

// 请求拦截
request.interceptors.request.use(
  (config) => {
    if (config.method == 'get') {
      config.params = {
        ...config.params,
        token: getToken(),
        random: Math.random(),
      }
      if (config.params.new_token) {
        config.params.token = config.params.new_token
      }
      delete config.params.new_token
    } else {
      if (
        config.url.indexOf('/file/v1/upload') > -1 ||
        config.url.indexOf('/audio/upload') > -1 ||
        config.url.indexOf('/video/upload') > -1
      ) {
        config.baseURL =
          window.location.href.indexOf(
            'test.patrol.h5.xiaoqiandao.com'
          ) > -1 || ENV == 'TEST'
            ? 'https://pre.weiyoubot.cn/xcx'
            : 'https://api-xcx-qunsou.weiyoubot.cn/xcx'
      } else if (config.url.indexOf('/login') == -1) {
        config.data = {
          ...config.data,
          token: getToken(),
        }
      }
      if (config.data.new_token) {
        config.data.token = config.data.new_token
      }
      delete config.data.new_token
    }
    if (
      config.url.indexOf('/login') == -1 &&
      config.url.indexOf('/signature') == -1 &&
      config.url.indexOf('/v1/targets') == -1 &&
      config.url.indexOf('/v1/shop/improves') == -1
    ) {
      showLoading()
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
// 响应拦截
request.interceptors.response.use(
  async (res) => {
    hideLoading()
    if (res.data.sta == -500) {
      // 处理token过期
      showLoading('登录中')
      let login_result = await login()
      hideLoading()
      if (login_result) {
        return request(res.config)
      }
    } else if (res.data.sta == 0) {
      return res.data
    } else if (res.data.sta == -1) {
      if (res.data.errcode == 102) {
        // 别人已经提交了无需重复提交
        return Promise.reject(res.data)
      } else {
        // 处理报错，弹出一个Toast
        showDialog({ message: res.data.msg })
        return Promise.reject(res.data)
      }
    }
  },
  (error) => {
    if (error.message.indexOf('Timeout') == -1) {
      showDialog({ message: error.message })
    }
    return Promise.reject(error)
  }
)

export default request
